import { NOTIFICATION_TYPE } from '@yandex-int/k-common';
import * as api from '@yandex-int/k-common/client/api';
import { delay, call, put, takeEvery, takeLatest, all } from 'redux-saga/effects';

import { MS_IN_MIN } from '../../utils/ms-in-units';
import { reportMessage } from '../../utils/raven-message';
import { showNetworkError } from '../notification/actions';

import * as actions from './actions';
import * as constants from './constants';

const DELAY_REPEAT_NOTIFICATION_REQUEST_MS = 10 * MS_IN_MIN;
const HEADER_NOTIFICATIONS_COUNT = 4;

export function* notificationsSagasWatcher() {
    yield all([
        takeLatest(constants.GET_NOTIFICATIONS_REQUEST, getNotificationsSaga),
        takeLatest(constants.GET_NOTIFICATIONS_HEADER_REQUEST, getNotificationsHeaderSaga),
        takeEvery(constants.UPDATE_NOTIFICATIONS_REQUEST, updateNotificationsSaga),
    ]);
}

function* getNotificationsSaga(action: ReturnType<typeof actions.getNotificationsRequest>) {
    try {
        const { payload } = action;
        const pageSize = payload?.pageSize || 1;
        const excludeTypes = [NOTIFICATION_TYPE.INTERFACE_ELEMENT_UNREAD];

        const { results } = yield call(api.getNotifications, { excludeTypes, pageSize });
        yield put(actions.getNotificationsSuccess(results));
    } catch (error) {
        console.error(error);
        reportMessage(`Произошла ошибка (${error.status}) при получении уведомлений`, error.message);

        yield put(actions.getNotificationsError());
    } finally {
        // чтобы нотификации появлялись у пользователей,
        // которые не любят обновлять страницу, запрашиваем нотификации с определенным интервалом
        // лишние запросы отрежет takeLatest выше
        yield delay(DELAY_REPEAT_NOTIFICATION_REQUEST_MS);
        yield put(actions.getNotificationsRequest());
    }
}

function* getNotificationsHeaderSaga(action: ReturnType<typeof actions.getNotificationsHeaderRequest>) {
    try {
        const { payload } = action;
        const pageSize = payload?.pageSize || HEADER_NOTIFICATIONS_COUNT;
        const includeTypes = [NOTIFICATION_TYPE.INTERFACE_ELEMENT_UNREAD];

        const { results } = yield call(api.getNotifications, { includeTypes, pageSize });
        yield put(actions.getNotificationsHeaderSuccess(results));
    } catch (error) {
        console.error(error);
        reportMessage(`Произошла ошибка (${error.status}) при получении уведомлений`, error.message);

        yield put(actions.getNotificationsHeaderError());
    } finally {
        yield delay(DELAY_REPEAT_NOTIFICATION_REQUEST_MS);
        yield put(actions.getNotificationsHeaderRequest());
    }
}

function* updateNotificationsSaga(action: ReturnType<typeof actions.updateNotificationsRequest>) {
    try {
        const { includeTypes, ids, isViewed } = action;

        yield call(api.patchNotifications, { ids, isViewed });
        yield put(actions.updateNotificationsSuccess());

        if (includeTypes?.includes(NOTIFICATION_TYPE.INTERFACE_ELEMENT_UNREAD)) {
            yield put(actions.getNotificationsHeaderRequest());
        } else {
            yield put(actions.getNotificationsRequest());
        }
    } catch (error) {
        console.error(error);

        yield put(actions.updateNotificationsError());
        yield put(showNetworkError(error));
    }
}
